// Use same-origin in production to avoid CORS issues
// Falls back to REACT_APP_BACKEND_URL for local development
const API = typeof window !== 'undefined' && window.location.hostname !== 'localhost'
  ? `${window.location.origin}/api`
  : `${process.env.REACT_APP_BACKEND_URL}/api`;

export default API;
